import { render, staticRenderFns } from "./GeneralAssessment.vue?vue&type=template&id=bc9eaf7e&scoped=true"
import script from "./GeneralAssessment.vue?vue&type=script&lang=js"
export * from "./GeneralAssessment.vue?vue&type=script&lang=js"
import style0 from "./GeneralAssessment.vue?vue&type=style&index=0&id=bc9eaf7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9eaf7e",
  null
  
)

export default component.exports